import React from 'react';
import Cookies from 'js-cookie';
import MaterialUIMultiLine from './MaterialUIMultiLine';
// import { ScrollTo, ScrollArea } from "react-scroll-to";
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
// import Icon from 'react-icons-kit';
import '../css/TicketSupport.css';


// ticket support page 
export default class TicketSupport extends React.Component{
    constructor(props){
    super(props);
    this.state = {
        error: 'some error',
        ticketNumber: window.location.pathname.substring(16),
        ticketReply: '',
        ticketHistory: [],
        chatHistory: '',
        ticketSubject: '',
        ticketStatus: '',
        disableInputBox: false,
        isAttachment: false,
        currentAttachment: '',
    }

    this.scrollToTop = this.scrollToTop.bind(this);
    }

    componentDidMount(){
        // console.log(this.props.match.params.value)
        this.fetchTickets();
        this.chatHistory();

        Events.scrollEvent.register('begin', function () {
            console.log("begin", arguments);
          });
      
          Events.scrollEvent.register('end', function () {
            console.log("end", arguments);
          });          
    }
      scrollToTop() {
        scroll.scrollToTop();
      }
      scrollTo() {
        scroller.scrollTo('scroll-to-element', {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart'
        })
      }
      scrollToWithContainer() {    
        let goToContainer = new Promise((resolve, reject) => {
    
          Events.scrollEvent.register('end', () => {
            resolve();
            Events.scrollEvent.remove('end');
          });
    
          scroller.scrollTo('scroll-container', {
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart'
          });
    
        });
    
        goToContainer.then(() =>
          scroller.scrollTo('scroll-container-second-element', {
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart',
            containerId: 'scroll-container'
          }));
      }
      
      componentWillUnmount() {
        Events.scrollEvent.remove('begin');
        Events.scrollEvent.remove('end');
      }
    fetchTickets = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
        }
        fetch(`/cloud/chatdata/${this.state.ticketNumber}`, {
          method: "GET",
          headers: headers,
        })
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
          .then(data => {
              console.log(data)
              console.log(data.message)
            this.setState({
                ticketHistory: data.message,
                ticketSubject: data.subject,
                ticketStatus: data.status,
                isAttachment: false,
                currentAttachment: ''
                
            },()=>{this.chatHistory()})   
          })
          .catch((err)=>{
            console.log(err)

          })
      }


    sendReply = (e) => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
        }
        if(this.state.ticketReply.trim()!=='' || this.state.isAttachment){
            this.setState({
                disableInputBox: true
            },()=>{
                fetch('/cloud/ticketreply/', {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify({
                        message_reply: this.state.ticketReply.trim(),
                        ticket_id: this.state.ticketNumber,
                        is_attachment: this.state.isAttachment ? 'True' : 'False',
                        attachment: this.state.currentAttachment
                    })
                })
                         .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
                .then(data => {
                    this.setState({
                        ticketHistory: data
                    },()=>{
                        this.setState({
                            message_reply: '',
                            disableInputBox: false
                        },()=>this.forceUpdate())
                        this.fetchTickets()              
                    })  
                })
                .catch((err)=>{
                  console.log(err)
      
                })
            })
        }
    }  
    

    toggleTicketStatus = (e) => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
        }
        fetch('/cloud/ticketreply/', {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            status:  this.state.ticketStatus==='Open' ? 'Closed' : 'Open',
            ticket_id: this.state.ticketNumber
          })
        })
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
          .then(data => {
            if(data.message==='Success'){
                {this.fetchTickets()}
            }else{
                alert(data.message)
            }
          })
          .catch((err)=>{
            console.log(err)

          })
          
    }  
    

    handleInputChange = (valueName,value) => {
        this.setState({
            [valueName]: value,
            message_reply: value 
        })
    }

    handleSubmit = (das) =>{
        this.sendReply();
    }

    opensupportimage = (attachment,action) => {
        if(action=='open'){
            this.imgUrlToBase64(attachment);
        } 
        this.setState({
            showsupportimg: !this.state.showsupportimg,
        }); 
    }

    imgUrlToBase64 =(url) =>{ 
        url = '/media/'+url;
        console.log(url) 
        this.toDataURL(url, (dataUrl) => {
          console.log(dataUrl);
          this.setState({
            supportmainimg: dataUrl,
          },()=>console.log(this.state.supportmainimg))
         })  
      }

      toDataURL =(url, callback) => {
        var httpRequest = new XMLHttpRequest();
        httpRequest.onload = function() {
           var fileReader = new FileReader();
              fileReader.onloadend = function() {
                 callback(fileReader.result);
              }
              fileReader.readAsDataURL(httpRequest.response);
        };
        httpRequest.open('GET', url);
        httpRequest.responseType = 'blob';
        httpRequest.send();
      }
      


    chatHistory = () => {
       let chatElement = this.state.ticketHistory.map((firstElement)=>{
           let xx = String(firstElement.attachment);

            if(firstElement.user_id==='mannan'){
                return (
                    <tr className="d-flex flex-fill my-3">
                     <div className="flex-grow-1" style={{width: '10%', marginTop: 'auto'}}>
                        </div>
                        <div className="align-self-end p-4 text-right" style={{minWidth: '10%', maxWidth: '60%', backgroundColor: '#00b0a9', borderRadius: '20px 20px 0px 20px', color: 'white', whiteSpace: 'pre-wrap'}}>
                            {firstElement.message}
                            {firstElement.is_attachment==='True' ? <a class="viewmassage"  onClick={this.opensupportimage.bind(this,firstElement.attachment,'open')}> <br/>
                            <u style={{color: 'blue'}}>
                            {firstElement.attachment}
                            </u>
                            </a> : null}
                        </div>                                   
                        <div style={{width: '10%', marginTop: 'auto', marginLeft: '1%'}}>
                        <i className="fas fa-headset fa-3x"></i>
                        </div>                          
                </tr>
                );
            }else{
                return (
                    <tr>
                    <div className="d-flex my-3">
                        <div style={{width: '5%', marginTop: 'auto', marginRight: '1%'}}>
                        <i className="fas fa-user fa-3x"></i>
                        </div>
                        <div className="align-self-end p-4" style={{minWidth: '10%',maxWidth: '60%', backgroundColor: 'white', borderRadius: '20px 20px 20px 0px', whiteSpace: 'pre-wrap'}}>
                           {firstElement.message}
                           {firstElement.is_attachment==='True' ? <a class="viewmassage"  onClick={this.opensupportimage.bind(this,firstElement.attachment,'open')}> 
                           <br/>
                           <u style={{color: 'blue'}}>
                            {firstElement.attachment}
                            </u></a> : null}
                        </div>                                   
                        <div style={{width: '5%', marginTop: 'auto'}}>
                        </div>
                    </div>   
                </tr>
                );
            }
        })
        this.setState({
            chatHistory: chatElement
        },()=>this.scrollToWithContainer())
        return chatElement;    
    }

    getBase64 = (event) => {
        var input = event.target;      
        var reader = new FileReader();
        reader.onload = () => {
          this.setState({
            currentAttachment: reader.result,
            isAttachment: true,
          })      
        }
        reader.readAsDataURL(input.files[0]);  
      };

    render(){
        return (
           <React.Fragment>
         {this.state.showsupportimg? 
                <div className="supportdiv">
                    <a className="supportclosediv" onClick={this.opensupportimage.bind(this,'text','close')}>X</a>
                    <div className="supportimgdiv">
                        {/* <img src="http://192.168.0.21:8000/media/00745b6a-1a4.png" /> */}
                        <img src={this.state.supportmainimg}  class="center" style={{height: '50%', width: '50%'}}/>
                    </div>
                </div>
            :null}
                 <div style={{marginRight: '5%', marginLeft: '5%', marginTop: '4%', marginBottom: '5%', maxHeight: '70vh'}}>
                    <div className="row" style={{  fontSize: '2rem', color: '#7C7D7D', fontWeight: 'lighter',marginLeft: '0%' }}>
                            Support  Ticket No: <span style={{fontSize: '2.10rem', color: 'black', fontWeight: 'bolder'}}>&nbsp; {this.state.ticketNumber}</span> <span className="ml-auto" onClick={(e)=>this.toggleTicketStatus()}>
                            <div className="addRightSi pointer" >
                                <div className="buttonContent">
                                    {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                                    <span>{this.state.ticketStatus==='Open' ? 'Close' : 'Reopen'}</span>
                                </div>
                                </div>    
                                </span>                
                    </div>
                    <br/>
                    <div className="row" style={{  fontSize: '1.5rem', color: '#7C7D7D', fontWeight: 'bolder',marginLeft: '0%' }}>
                            Subject: <span style={{fontSize: '1.25rem', fontWeight: 'lighter'}}>&nbsp; {this.state.ticketSubject}</span>            
                    </div>
                    <br/>
                    <div className="row" style={{  fontSize: '1.5rem', color: '#7C7D7D', fontWeight: 'bolder',marginLeft: '0%' }}>
                            Status: <span style={{fontSize: '1.25rem', fontWeight: 'lighter'}}>&nbsp; {this.state.ticketStatus}</span>            
                    </div>                             
                    <table style={{minWidth: '0px'}} className="tablel">
                            <tbody  id="myDiv">
        <Element className="element" id="scroll-container" style={{
            position: 'relative',
            height: '80vh',
            overflow: 'scroll',
            marginBottom: '1px'
          }}>

            <Element name="scroll-container-first-element" style={{
              marginBottom: '1px'
            }}>              
          </Element>
          {this.state.chatHistory} 
            <Element name="scroll-container-second-element" style={{
              marginBottom: '1px'
            }}>              
          </Element>
          </Element> 
        <tr style={{'minHeight': '6vh'}}>
            </tr>                            
                            </tbody>                        
                        </table>
                        <div style={{ position: 'fixed',left: '20%',bottom: '0',width: '100%', height: '6vh', backgroundColor: 'white', padding: '0.1%' }}>
                        <div className="container container-fluid mx-0 px-0" style={{width: '80%', maxWidth: '80%'}}>
                        <div className="d-flex bd-highlight" >
                         <div className="bd-highlight">
                            <div className="p-2 m-2">
                                 <label htmlFor="dd" style={{pointerEvents: "all", cursor: 'pointer' }}>
                                    <i  className="fas fa-paperclip fa-2x"></i>
                                </label>
                                    <input id="dd" type='file' accept=".jpg,.png" onChange={this.getBase64.bind(this)} style={{display: 'none'}} />
                            </div>
                        </div>
                        <div className="flex-grow-1 bd-highlight border" style={{bottom: '1%'}}>
                        <MaterialUIMultiLine                         
                        placeholder="Write response here"
                        handleInputChange = {this.handleInputChange.bind(this)}
                        handeSubmitReply={this.handleSubmit.bind(this)}
                        name='ticketReply'
                        inputValue={this.state.message_reply}    
                        disabled={this.state.disableInputBox}                    
                        />
                        </div>
                        <div className="p-2">
                        <i className="fas fa-sign-in-alt fa-2x pointer" onClick={()=>{this.sendReply()}}></i>
                        </div>
                        </div>
                        </div>
                            </div>
                </div>
           </React.Fragment>
        )
    }

}